import React from "react";
import Table from "../Shared/Table";

import {
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    Row,
    Col,
    Button
} from "reactstrap";

import { phoneNumber } from "core/UrlEndpoints";
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import { useHistory } from "react-router-dom";

const PhoneNumberList = () => {
    const history = useHistory();

    return (
        <>
            <PanelHeader
                content={
                    <div className="header text-center">
                        <h2 className="title">Phone Numbers</h2>
                    </div>
                }
            />
            <div className="content">
                <Row>
                    <Col xs={12} md={12}>
                        <Card>
                            <CardHeader>
                                <CardTitle tag="h4">Phone Numbers</CardTitle>
                                <Button
                                    color="primary"
                                    onClick={() => history.push(`phonenumbers/add`)}>
                                    Add
                                </Button>
                            </CardHeader>
                            <CardBody>
                                <Table
                                    url={phoneNumber}
                                    columns={[
                                        {
                                            header: "Phone Number",
                                            accessorKey: "phoneNumber",
                                        },
                                        {
                                            header: "Name",
                                            accessorKey: "name",
                                        },


                                    ]}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
};

export default PhoneNumberList;
